export default __webpack_public_path__ + "static/media/cloud-school.9cf0e8c2.webp";